<template>
	<div class="contactBox">
		<div class="banner">
			<div class="txt">CONTACT US<br>联系我们</div>
			<ul class="list flexBox">
				<li v-for="item in bannerList">
					<p class="name">{{item.title}}</p>
					<p class="des" v-html="item.content" style="white-space: pre-wrap;"></p>
				</li>
			</ul>
		</div>
		<div class="serveBox">
			<div class="title">为您提供7*24小时专业技术咨询服务</div>
			<ul class="list row">
				<li class="fl" v-for="(item,idx) in serveList" :class="serveIdx == idx ?'active':''"
					@mouseenter="clickServe(idx)">
					<i class="bgImg" :style="{'backgroundImage':'url('+item.imageUrl+')'}"></i>
					<img :src="item.iconUrl" class="icon">
					<div class="name">{{item.title}}</div>
					<div class="tip" v-html="item.content" style="white-space: pre-wrap;"></div>
					<div class="more" @click="clickServeMore(item)">了解详情<a-icon type="arrow-right"
							class="tag" />
					</div>
				</li>
			</ul>
		</div>
		<div class="handBox">
			<div class="infoBox">
				<div class="moreBox">
					<router-link to="/recruit" class="more">
						<div class="flexBox">
							<p class="txt">了解更多招聘职位</p>
							<a-icon type="arrow-right" />
						</div>
					</router-link>
				</div>
				<ul class="list row">
					<li class="flexBox" v-for="item in handList">
						<div class="icon"></div>
						<div class="box">
							<div class="name">{{item.title}}</div>
							<div class="val">共招聘{{item.headcount}}个职位</div>
						</div>
						<div class="more" @click="clickMore(item)">
							<img src="../assets/img/contact/right.png" class="tag">
						</div>
					</li>
				</ul>
			</div>
		</div>

		
	</div>
</template>

<script>
	export default {
		name: 'ContactPhone',
		components: {

		},
		data() {
			return {
				bannerList: [{
					name: '顶尖专家团队权威指导',
					des: "权威认证专家团队与您深入交流合作<br>携手同行高速发展"
				}, {
					name: '全业务场景深度触达',
					des: "全方位服务支持，深入场景答疑解惑<br>满足您各类业务诉求"
				}, {
					name: '量身定制专属化服务',
					des: "萃取全球项目经验<br>为您量身定制最合适的解决方案"
				}],
				serveIdx: 0,
				serveList: [],
				handList: [],
				canLoad: true,
				show: false,
			}
		},
		watch: {
			isRendered(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.show = true
					})
				}
			}
		},
		mounted() {
			this.getData();
		},
		
		methods: {
			clickServe(idx) {
				this.serveIdx = idx;
			},
			getData() {
				this.$req("get", "/api/cms/jobPosition/list", {
					params: {
						pageNum: 1,
						pageSize: 8,
					}
				}).then((res) => {
					this.handList = res.rows;
				});
			
			
				this.$req("get", "/api/cms/banner/listByCode/contact_info").then((res) => {
					this.bannerList = res.data;
				});
			
				this.$req("get", "/api/cms/banner/listByCode/contact_services").then((res) => {
					this.serveList = res.data;
				});
			},
			clickServeMore(item) {
				if (item.linkUrl != null) {
					this.$tools.checkLoginAndJump(item.linkUrl);
				};
			},
			clickMore(item) {
				this.$router.push({
					path: "/recruit",
					query: {
						id: item.id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.contactBox .banner {
		height: 108rem;
		width: 100%;
		background-image: url("../assets/img/contact/banner_0.jpg");
		background-size: 100% 100%;
		background-position: center;
		padding: 26rem 26rem 0;
		font-size: 3rem;
		line-height: 4rem;
		color: #fff;
		position: relative;
	}
	
	.contactBox .banner .list {
		width: 100%;
		height: 38.4rem;
		background-color: rgba(229, 229, 229, 0.5);
		position: absolute;
		bottom: 0;
		left: 0;
		padding: 0 26rem;
	}
	.contactBox .banner .list li:first-child{
		border-left: 1px solid #bcbdc1;
	}
	.contactBox .banner .list li {
		width: 33.333%;
		border-right: 1px solid #bcbdc1;
		text-align: center;
		justify-content: center;
		display: flex;
		flex-direction: column;
	}
	
	.contactBox .banner .list li .name {
		font-size: 2.6rem;
		color: #000;
		line-height: 6rem;
		margin: 0 0 2rem;
		font-weight: bold;
	}
	
	.contactBox .banner .list li .des {
		font-size: 2rem;
		color: #555;
		line-height: 3.2rem;
	}
	
	.contactBox .serveBox {
		width: 100%;
		height: 54rem;
		background-image: url("../assets/img/contact/banner_2.jpg");
		background-size: 100% 100%;
		padding: 7rem 0 0;
	}
	
	.contactBox .serveBox .title {
		font-size: 3.2rem;
		line-height: 4.2rem;
		text-align: center;
		color: #000;
		margin: 0 0 5rem;
	}
	
	.contactBox .serveBox .list {
		margin: 0 auto;
		width: 144rem;
		height: 30rem;
		overflow: hidden;
	}
	
	.contactBox .serveBox .list li {
		width: 20rem;
		height: 30rem;
		background: linear-gradient(180deg, #ffffff 0%, #E5F6FF 100%);
		margin: 0 1rem;
		padding: 5rem 0 0 3rem;
		overflow: hidden;
		cursor: pointer;
		position: relative;
		max-width: 74rem;
	}
	
	.contactBox .serveBox .list li .icon {
		height: 4.8rem;
		margin: 0 0 7rem;
	}
	.contactBox .serveBox .list li::before{
		width: 30rem;
		height: 30rem;
		position: absolute;
		top: 0;
		left: 0;
		content: "";
		display: block;
		background-size: 74rem 30rem !important;
		background-repeat: no-repeat !important;
	}
	
	.contactBox .serveBox .list li .bgImg {
		width: 30rem;
		height: 38rem;
		position: absolute;
		top: 0;
		left: 0;
		content: "";
		display: block;
		background-size: 74rem 38rem !important;
		background-repeat: no-repeat !important;
		opacity: 0;
	}
	
	.contactBox .serveBox .list li.active {
		width: 74rem;
		background: none;
	}
	
	.contactBox .serveBox .list li.active .bgImg {
		width: 74rem;
		opacity: 1;
		transition: all 0.2s linear;
	}
	
	.contactBox .serveBox .list li.active::before{
		width: 74rem;
		transition: all 0.2s linear;
	}
	
	.contactBox .serveBox .list li.active .icon {
		display: none;
	}
	
	.contactBox .serveBox .list li.active .name {
		color: #fff;
	}
	
	.contactBox .serveBox .list li.active .tip {
		color: #fff;
	}
	
	.contactBox .serveBox .list li .name {
		font-size: 2.4rem;
		font-weight: bold;
		line-height: 3.2rem;
		margin: 0 0 1.5rem;
		position: relative;
		z-index: 1;
	}
	
	.contactBox .serveBox .list li .tip {
		color: #747474;
		font-size: 1.4rem;
		line-height: 2.2rem;
		height: 6.6rem;
		margin: 0 0 3rem;
		position: relative;
		z-index: 1;
	}
	
	.contactBox .serveBox .list li .more {
		color: #fff;
		font-size: 1.6rem;
		line-height: 2.4rem;
		cursor: pointer;
		position: relative;
		z-index: 1;
		display: inline-block;
	}
	
	.contactBox .serveBox .list li .more:hover {
		color: #09A9D9;
		transition: all 0.2s linear;
		-moz-transition: all 0.2s linear;
		-webkit-transition: all 0.2s linear;
		-o-transition: all 0.2s linear;
	}
	
	.contactBox .serveBox .list li .more .tag {
		margin: 0 0 0 0.5rem;
		transform: translate3d(0, 0.1rem, 0);
	}
	
	.contactBox .handBox{
		width: 100%;
		height: 62rem;
		background-image: url("../assets/img/contact/banner_1.jpg");
		background-size: 100% 100%;
		padding: 31rem;
	}
	.contactBox .handBox .list{
		width: 144rem;
		margin: 0 auto;
	}
	.contactBox .handBox .list li{
		width: 33.5rem;
		height: 10rem;
		margin: 1rem;
		float: left;
		background: #FEFFFF;
		padding: 0 3.5rem;
		align-items: center;
		position: relative;
		cursor: pointer;
	}
	.contactBox .handBox .list li .icon{
		width: 3rem;
		height: 3rem;
		background-image: url("../assets/img/contact/icon_5.png");
		background-size: auto 100%;
		background-position: center;
		background-repeat: no-repeat;
		margin: 0 2rem 0 0;
	}
	.contactBox .handBox .list li .name{
		font-size: 1.8rem;
		color:#010101;
		line-height: 2.2rem;
		margin: 0 0 0.5rem;
	}
	.contactBox .handBox .list li .val{
		color:#999;
		font-size: 1.4rem;
		line-height: 2rem;
	}
	.contactBox .handBox .list li .more{
		position: absolute;
		width: 3.5rem;
		height: 3.5rem;
		right: 7rem;
		opacity: 0;
	}
	.contactBox .handBox .list li .more img{
		width: 100%;
		height: 100%
	}
	.contactBox .handBox .list li:hover .icon{
		background-image: url("../assets/img/contact/icon_4.png");
	}
	.contactBox .handBox .list li:hover .more{
		opacity: 1;
		right: 3.5rem;
		transition: all 0.2s linear;
	}
	.contactBox .handBox .list li:hover .name{
		color:#0076FF
	}
	
	
	.contactBox .handBox .moreBox{
		text-align: right;
		width: 144rem;
		margin: 0 auto;
		padding: 0 3.5rem 0 0;
	}
	.contactBox .handBox .moreBox .more{
		color:#fff;
		font-size: 1.6rem;
		line-height: 2.2rem;
		justify-content: right;
		align-items: center;
	}
	.contactBox .handBox .moreBox .more .txt{
		color:#fff;
	}
	.contactBox .handBox .moreBox .more .anticon{
		color:#fff;
		font-size: 1.6rem;
		line-height: 2.2rem;
		transform: translate3d(0, 0.2rem, 0);
		margin: 0 0 0 0.5rem;
	}
	.contactBox .handBox .moreBox .more:hover .txt{
		opacity: 0.8;
	}
	.contactBox .handBox .moreBox .more:hover .anticon{
		opacity: 0.8;
	}
</style>